import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';
import { ImageLayoutComponent } from '@app/shared/components/image-layout/image-layout.component';
import { DfIconModule } from '@lib/fresco';
import { TranslateService } from '@ngx-translate/core';
import { Duration, Input as Content } from '@app/inputs/inputs-api.model';
import { GetTargetResponse } from '@app/target/target-api.model';
import { PathwaySummaryModel } from '@dg/pathways-rsm';
import { JsonObject } from '@app/shared/models/core-api.model';

export interface ContentResult extends LearningResourceViewModel, Duration {}
export type FetchedInternalLinkObject =
  | GetTargetResponse
  | PathwaySummaryModel
  | Content<JsonObject>;

@Component({
    selector: 'dgx-content-result',
    templateUrl: './content-result.component.html',
    styleUrls: ['./content-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgbTooltip, DfIconModule, ImageLayoutComponent]
})
export class ContentResultComponent implements OnChanges {
  @Input() public item: ContentResult | any;
  @Input() public endorsedSrc: string;

  @Output() public remove? = new EventEmitter<ContentResult>();

  public i18n = this.translateService.instant([
    'Core_Duration',
    'Core_Endorsed',
    'Core_Remove',
    'dgOrgInternalContent_ContentType',
  ]);
  public ariaLabelForRemoveContent: string;
  public title = '';
  public description = '';

  public get isRemovable(): boolean {
    return this.remove?.observed;
  }

  constructor(private translateService: TranslateService) {}

  public ngOnChanges({ item }: SimpleChanges) {
    if (!item) {
      return;
    }
    this.title = this.item.title || (this.item as any).name;
    this.description = this.translateService.instant(
      `Core_${this.item.resourceType}`
    );
    this.ariaLabelForRemoveContent = this.translateService.instant(
      'A11y_RemoveContent',
      {
        contentType: this.description,
        contentTitle: this.item.title,
      }
    );
  }
}
